var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TeamPage content inner-grid-container"},[_c('div',{staticClass:"banner"},[_c('Banner',{staticClass:"fancyHeading",attrs:{"text":_vm.team.name}})],1),_c('div',{staticClass:"add-player"},[_c('AddPlayers',{attrs:{"team":_vm.team}})],1),_c('div',{staticClass:"team-stats"},[_c('div',{staticClass:"addText"},[_vm._v("AVERAGE TEAM STATS")]),_c('TeamStatsCard',{attrs:{"team":_vm.team}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5315e86c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TeamPage.vue
// module id = null
// module chunks = 